module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"quickDeal":"Quick Lead"},"fr":{"quickDeal":"Référence rapide"}}')
  delete Component.options._Ctor
}
